<template>
  <el-alert
    :class="isTopLine?'topNote':''"
    title=""
    type="warning">
    <div class="importantNote">
      <i class="iconfont icon-kaiqi f16 col_FEAF0D mr5"></i>
      <slot></slot>
    </div>
  </el-alert>
</template>

<script>
export default {
  name: 'OtsTipline',
  props: {
    isTopLine: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang='less' scoped>
.el-alert {
    height: 36px;
    line-height: 36px;
    .importantNote {
        font-size: 14px;
        color: #FF9500;
        margin-left: -10px;
        margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      color: #FF9500;
    }
}
.el-alert.topNote {
    margin-bottom: 24px;
    background: #FFF5E0;
    border: 1px solid #FF9500;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    .importantNote {
        font-size: 14px;
        color: #FF9500;
        margin-left: -10px;
        margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #FF9500;
    }
}
</style>